module.exports = __webpack_public_path__ + "d308073b/img/ion_calendar-number.3ac5bd07.svg";